module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "my-question-asw"
  }, [_c('tab-header', {
    attrs: {
      "tabList": _vm.questionTabList,
      "tabName": _vm.tabName,
      "isSelf": _vm.isSelf
    },
    on: {
      "getTabName": _vm.getTabName,
      "getSortType": _vm.getSortType
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "question-asw-content"
  }, [(_vm.questionAswList.length) ? _c('ul', {
    staticClass: "question-asw-list"
  }, [(_vm.curTabName !== 'my_answer') ? _vm._l((_vm.questionAswList), function(item, index) {
    return _c('li', {
      key: index,
      class: [("data-item data-item" + (item.id))]
    }, [_c('div', {
      staticClass: "head"
    }, [(item.comment_is_accept_by_topic) ? _c('span', {
      staticClass: "tag solved"
    }, [_vm._v("已解决")]) : _vm._e(), _vm._v(" "), _c('h3', {
      class: ['question-name', {
        'is-delete': item.status === 'Delete'
      }],
      on: {
        "click": function($event) {
          return _vm.goQuestionDetail(item)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.title) + "\n                        ")]), _vm._v(" "), (item.status === 'Delete') ? _c('span', {
      staticClass: "tag deleted"
    }, [_vm._v("已删除")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "comment-bottom-content"
    }, [_c('div', {
      staticClass: "answer-list"
    }, [_c('p', {
      staticClass: "answer-text comment",
      on: {
        "click": function($event) {
          return _vm.goQuestionDetail(item, true)
        }
      }
    }, [_c('i', {
      staticClass: "smart-img"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.no_of_comment)), _c('i', {
      staticClass: "text"
    }, [_vm._v("回答")])])]), _vm._v(" "), _c('p', {
      staticClass: "answer-text view"
    }, [_c('i', {
      staticClass: "smart-icon view-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("transformUnit")(item.no_of_views))), _c('i', {
      staticClass: "text"
    }, [_vm._v("阅览")])])]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "effect": "dark",
        "content": item.is_followed ? '取消关注' : '关注问题',
        "placement": "top"
      }
    }, [_c('p', {
      staticClass: "answer-text followed",
      class: {
        'active': item.is_followed
      },
      on: {
        "click": function($event) {
          return _vm.handleFollowToggle(item)
        }
      }
    }, [_c('i', {
      staticClass: "smart-img follow-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.no_of_followed)), _c('i', {
      staticClass: "text"
    }, [_vm._v("关注")])])])]), _vm._v(" "), (_vm.isSelf && item.created_by.user_id === _vm.userId) ? [_c('p', {
      staticClass: "answer-text edit",
      on: {
        "click": function($event) {
          return _vm.editeArticle(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "smart-img"
    }), _vm._v(" "), _c('span', [_vm._v("编辑")])]), _vm._v(" "), _c('p', {
      staticClass: "answer-text delete",
      on: {
        "click": function($event) {
          return _vm.deleteArticle(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "smart-img"
    }), _vm._v(" "), _c('span', [_vm._v("删除")])])] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "topic-people"
    }, [_vm._v(_vm._s(item.created_by.nick_name) + " 于 " + _vm._s(item.created_on) + "发布")])])])
  }) : _vm._l((_vm.questionAswList), function(item, index) {
    return _c('li', {
      key: index,
      class: [("data-item data-item" + (item.id)), 'is-answer']
    }, [_c('h3', {
      staticClass: "question-name",
      on: {
        "click": function($event) {
          return _vm.goQuestionDetail({
            id: item.topic_id
          })
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.topic_title) + "\n                    ")]), _vm._v(" "), _c('answer', {
      key: item.id,
      attrs: {
        "comment": item,
        "isSelf": _vm.isSelf
      },
      on: {
        "goHomePage": _vm.goHomePage,
        "deleteArticle": _vm.deleteArticle,
        "onApproval": _vm.onApproval
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.questionAswList.length && !_vm.isLoading),
      expression: "!questionAswList.length && !isLoading"
    }],
    staticClass: "content-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../images/personal_center/data-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]), _vm._v(" "), (_vm.isMoreLoading || _vm.questionAswList.length) ? _c('div', {
    staticClass: "load-more"
  }, [(_vm.isMoreLoading) ? _c('img', {
    attrs: {
      "alt": "loading",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.totalPage === _vm.curPage ? '没有更多内容了' : '显示更多'))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-09660172!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/my_question.vue
// module id = BMvT
// module chunks = 16